/* ═══════════════════════════════════════════════════════
   NYC Suite: bootstrapUser (browser to the bootstrapUser callable)
   ═══════════════════════════════════════════════════════
   First-sign-in provisioning for allow-listed accounts (docs/holds/holds-plan.md
   §8). The server reads the verified token email, looks it up in
   app/allowed_users/members, and creates users/{uid} with exactly that role when
   the document is missing. The browser never writes users/{uid}. Mirrors the
   callCalendar pattern in lib/calendarClient.js.
*/
import { callable } from "../firebase.js";

// Returns { role, apps, created }. Throws the Firebase HttpsError as is
// (e.code "permission-denied" for an email that is not enrolled).
export async function bootstrapUser() {
  const fn = callable("bootstrapUser");
  const res = await fn({});
  return res?.data || null;
}
